import React from "react";
import { useUser } from "components/hooks/useUser";
import { PopoverHeader } from "../PopoverHeader";
import { BMailItem } from "./BMailItem";
import { ListContainer } from "../ListContainer";
import { NoItems } from "./NoItems";

export function BMailPopover() {
  const { badges: { bmail: { items = [] } = {} } = {} } = useUser(
    (user) => user.bconnected
  );

  return (
    <>
      <PopoverHeader service="Mail" />
      {items.length > 0 ? (
        <ListContainer>
          {items.map((item, index) => (
            <BMailItem key={index} item={item} />
          ))}
        </ListContainer>
      ) : (
        <NoItems service="Mail" />
      )}
    </>
  );
}
